export * from './fgts-factory'
